import { StoreAccessor, GetDocs, GetDoc } from "mobx-firelink";
export const GetAttributes = StoreAccessor("GetAttributes", s => () => {
    return GetDocs({}, a => a.attributes);
});
export const GetAttribute = StoreAccessor("GetAttribute", s => (id) => {
    if (id == null)
        return null;
    return GetDoc({}, a => a.attributes.get(id));
});
